<mat-button-toggle-group class="display-toggle-buttons" [formControl]="displayControl" [hideSingleSelectionIndicator]="true" aria-label="Status Filter">
  @for (statusItem of statusList; track statusItem) {
    <mat-button-toggle [value]="statusItem.value" [disableRipple]="true">
      @if (statusItem.icon) {
        <fa-icon [icon]="statusItem.icon"></fa-icon>
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>
